<template>
  <div id="sidebar-components" @click="clickAway">
    <transition name="slide-fade">
      <div class="content-part" v-if="showSidebar" @click.stop>
        <component :is="component.bind.is"></component>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: "Sidebar",
  props: {
    component: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showSidebar: true
    };
  },
  created() {
    // This showSidebar is important for the transition!
    this.showSidebar = false;
    window.addEventListener("keyup", this.handleKeyup);
  },
  mounted() {
    this.showSidebar = true;
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this.handleKeyup);
  },
  methods: {
    handleKeyup(event) {
      if (event.key === "Escape") {
        this.closeSidebar();
      }
    },
    clickAway() {
      this.closeSidebar();
    },
    closeSidebar() {
      this.showSidebar = false;
      setTimeout(() => {
        this.$eventBus.closeSidebar();
      }, 500);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#sidebar-components {
  width: 100vw !important;
  height: 100vh !important;
  position: fixed;
  top: 0;
  left: 0;
  z-index: $Z-sidebar;
  display: flex;
  flex-direction: row;
  background-color: transparent;
  // backdrop-filter: $backdrop-filter;
  .content-part {
    width: $vertical-navbar-width;
    height: 100%;
    background: white;
    box-shadow: $basic-shadow;
  }
}
</style>
